import { Link } from "react-router-dom";
import { Chrome, Lock } from "lucide-react";

export const LoginGate = () => {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/conteudo";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="login-gate" className="flex min-h-screen items-center justify-center bg-black px-6">
      <div className="w-full max-w-md border border-white/10 bg-[#0A0A0A] p-10">
        <div className="flex items-center gap-2">
          <span className="h-3 w-3 bg-krono" aria-hidden="true" />
          <span className="font-display text-xl font-black tracking-tighter text-white">KRONO</span>
        </div>
        <p className="mt-8 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-krono">
          <Lock className="h-3.5 w-3.5" /> Área restrita
        </p>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-white">
          Pacote de conteúdo @krono.paint
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-white/60">
          Artes, legendas e roteiros de Reels do mês. Entre com sua conta Google autorizada para acessar.
        </p>
        <button
          onClick={login}
          data-testid="google-login-button"
          className="mt-8 flex w-full items-center justify-center gap-3 bg-white px-6 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-black transition-colors hover:bg-krono"
        >
          <Chrome className="h-4 w-4" />
          Entrar com Google
        </button>
        <Link
          to="/"
          data-testid="login-gate-back"
          className="mt-6 block text-center font-mono text-xs uppercase tracking-[0.2em] text-white/50 transition-colors hover:text-krono"
        >
          Voltar ao site
        </Link>
      </div>
    </div>
  );
};
